import { Injectable } from '@angular/core';
import { HeaderFooter } from '../Interface/PrimeraEtapa';

@Injectable({
  providedIn: 'root'
})
export class DomManagerService {

  constructor() { }

  /**
   * Actualiza el header del documento con el HTML proporcionado
   * @param headerData Datos del header con HTML y tipo de resolución
   */
  updateHeader(headerData: HeaderFooter): void {
    if (!headerData || !headerData.html) {
      console.warn('No se proporcionaron datos válidos para el header');
      return;
    }

    try {
      // Buscar el elemento header existente por ID
      const existingHeader = document.getElementById('dynamic-header');
      
      if (existingHeader) {
        // Reemplazar el contenido del header existente
        existingHeader.outerHTML = headerData.html;
      } else {
        // Si no existe un header, insertarlo después del body
        const body = document.body;
        if (body) {
          body.insertAdjacentHTML('afterbegin', headerData.html);
        }
      }
      
      console.log('Header actualizado exitosamente');
    } catch (error) {
      console.error('Error al actualizar el header:', error);
    }
  }

  /**
   * Actualiza el footer del documento con el HTML proporcionado
   * @param footerData Datos del footer con HTML y tipo de resolución
   */
  updateFooter(footerData: HeaderFooter): void {
    if (!footerData || !footerData.html) {
      console.warn('No se proporcionaron datos válidos para el footer');
      return;
    }

    try {
      // Buscar el elemento footer existente por ID
      const existingFooter = document.getElementById('dynamic-footer');
      
      if (existingFooter) {
        // Reemplazar el contenido del footer existente
        existingFooter.outerHTML = footerData.html;
      } else {
        // Si no existe un footer, insertarlo antes del cierre del body
        const body = document.body;
        if (body) {
          body.insertAdjacentHTML('beforeend', footerData.html);
        }
      }
      
      console.log('Footer actualizado exitosamente');
    } catch (error) {
      console.error('Error al actualizar el footer:', error);
    }
  }

  /**
   * Actualiza tanto header como footer en una sola operación
   * @param headerData Datos del header
   * @param footerData Datos del footer
   */
  updateHeaderAndFooter(headerData?: HeaderFooter, footerData?: HeaderFooter): void {
    if (headerData) {
      this.updateHeader(headerData);
    }
    
    if (footerData) {
      this.updateFooter(footerData);
    }
  }

  /**
   * Restaura el header y footer originales (opcional)
   * Útil para limpiar cambios dinámicos
   */
  restoreOriginalLayout(): void {
    // Esta función podría restaurar el layout original si es necesario
    // Por ahora solo logueamos la acción
    console.log('Restaurando layout original');
  }
}
